import { getBlockerStyle, spinnerKeyframe } from '@bingads-webui-campaign-react/common-styles';
import { shorthands, tokens } from '@fluentui/react-components';
import { Severity, IconErrorColor } from '../constants';

export const getCampaignMenuItemStyles = (_components, { palette }) => ({
  CampaignMenuItem: {
    alignItems: 'start',
    height: 'auto',
    minHeight: 32,
    '& .fui-MenuItem__icon': {
      height: 16,
      width: 16,
      minWidth: 16,
      fontSize: 16,
    },
    '& .fui-MenuItem__content': {
      color: tokens.colorBrandForegroundLink,
      wordBreak: 'break-word',
    },
  },
  CampaignItemIcon: {
    width: 16,
    minWidth: 16,
  },
  SeverityIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    position: 'relative',
  },
  [`CampaignSelectorItemGlyphicon-${Severity.AllCampaigns}`]: {
    color: palette.neutralPrimary,
  },
  [`CampaignSelectorItemGlyphicon-${Severity.Error}`]: {
    color: IconErrorColor,
  },
  [`CampaignSelectorItemGlyphicon-${Severity.Warning}`]: {
    color: palette.orange,
  },
});

export const getCampaignSelectorStyles = (_components, { palette }) => ({
  CampaignSelector: {
    '& .fui-MenuItem': {
      backgroundColor: 'transparent',
      color: tokens.colorNeutralForeground1,
      maxWidth: 'none',
      flexBasis: 'fit-content',
      flexShrink: 1,
      flexGrow: 1,
      ...shorthands.padding(tokens.spacingVerticalSNudge),
    },

    '& .fui-MenuGroupHeader': {
      ...shorthands.padding('0', 4),
    },

    '& .scope-filters': {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
  },
  ListMenuGroup: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: '0',
  },
  SearchBox: {
    marginTop: 4,
  },
  ScrollingContainer: {
    overflowX: 'hidden',
    overflowY: 'auto',
    scrollbarGutter: 'stable',
    maxHeight: '50vh',

    '&::-webkit-scrollbar': {
      backgroundColor: 'transparent',
      '-webkit-border-radius': 10,
      width: 8,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
      '-webkit-border-radius': 10,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      '-webkit-border-radius': 10,
      backgroundColor: tokens.colorNeutralForeground3,
    },
    ':hover': {
      overflowY: 'auto',
    },
  },
  PlaceholderNode: {
    height: 36,
    display: 'flex',
    alignItems: 'center',
    width: 240,
    paddingLeft: 16,
    paddingRight: 16,
  },
  PlaceholderNodeIcon: {
    marginRight: 3,
  },
  Spinner: getBlockerStyle(16, palette),
  ...spinnerKeyframe,
});
